export const AppColors = {
    primary : "#169948"
}